export default __webpack_public_path__ + "static/media/senior-java.1bafc673.png";